import { render } from "./VideoPlayer.vue?vue&type=template&id=7a830c5f&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=7a830c5f&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a830c5f"]])

export default __exports__